module.exports = __webpack_public_path__ + "static/media/img-latinhas-reciclagem.4356f52c.png";